const GUEST_OFFER_TOKEN_KEY = 'seminargo_guest_offer_token';
const GUEST_OFFER_ID_KEY = 'seminargo_guest_offer_id';

export const getStoredGuestOfferToken = (): string | null => {
  return sessionStorage.getItem(GUEST_OFFER_TOKEN_KEY);
};

export const getStoredGuestOfferId = (): number | null => {
  const raw = sessionStorage.getItem(GUEST_OFFER_ID_KEY);
  if (!raw) return null;
  const id = parseInt(raw, 10);
  return Number.isFinite(id) ? id : null;
};

export const setStoredGuestOfferAccess = (offerId: number, token: string): void => {
  sessionStorage.setItem(GUEST_OFFER_TOKEN_KEY, token);
  sessionStorage.setItem(GUEST_OFFER_ID_KEY, `${offerId}`);
};
